export enum TransactionStatusEnum {
  SUCCESS = 1,
  IGNORED = 2,
  PENDING = 3,
}

export enum TransactionType {
  Mirror = 0,
  Iceberg = 1,
  External = 2,
  Unknown = 3,
  PingPong = 4,
  MovingRange = 5,
  FixedRange = 6,
  Withdraw = 99,
}

export type DexTaskTransactionType = Exclude<TransactionType, TransactionType.Withdraw>;

const DEX_TASK_TRANSACTION_TYPES = new Set<number>(
  Object.values(TransactionType).filter(
    (value): value is TransactionType =>
      typeof value === 'number' && value !== TransactionType.Withdraw,
  ),
);

/** Narrows a raw API value to a task type the dashboard knows how to render and submit. */
export const isDexTaskTransactionType = (value: number): value is DexTaskTransactionType =>
  DEX_TASK_TRANSACTION_TYPES.has(value);

export interface GetListTransactionsParams {
  pid?: number;
  tid?: number;
  success?: number;
  type?: string;
  page?: number;
  limit?: number;
  withdraw?: boolean;
}

export interface DexTransaction {
  amountIn: number;
  amountOut: number;
  baseSymbol: string;
  block: number;
  datetime: string;
  details: string | null;
  direction: number;
  gasSpent: number;
  gasUsed: number;
  hash: string;
  id: number;
  message: string | null;
  name: string;
  nativeName: string;
  nativeUSDRate: number;
  pId: number;
  perc: number | null;
  price: number;
  priceUSD: number;
  quoteSymbol: string;
  scanUrl: string;
  status: TransactionStatusEnum;
  tId: number;
  token0Address: string | null;
  token0Symbol: string | null;
  token1Address: string | null;
  token1Symbol: string | null;
  triggerAmountIn: number;
  triggerAmountOut: number;
  triggerBlock: number | null;
  triggerGasSpent: number;
  triggerGasUsed: number;
  triggerHash: string | null;
  type: TransactionType;
  wId: number | null;
}

export interface DexServices {
  name: string;
  url: string;
  id: number;
  address: string;
}

export interface DexServicesResponse {
  status: boolean;
  data: DexServices[];
}

export interface DexTransactionsResponseError {
  status: boolean;
  message: string;
}

export interface DexTransactionResponse {
  status: boolean;
  data: {
    total: number;
    message: DexTransaction[] | string;
  };
}
